import React, { FC, useState } from "react";
import styled from "styled-components";
import { SmallText } from "../Components/Text3D";
import { Upload, Spin, notification, Typography, Button, Col, Descriptions } from "antd";
import UploadImg from '../assets/images/uploadImage.png';
import { useHistory } from "react-router-dom";
import { useStoreState, useStoreActions } from '../myStore/index';
import HeaderComponent from "../Components/HeaderComponents";
import FooterPublic3D from "../Components/FooterPublic3D";
import { PrimaryButtonX } from "../Components/Button3D";

const { Dragger } = Upload;

const MainContainer = styled.div`
`;
const ContentDiv = styled.div`
  width: 100%;
  margin-top: 2rem;
  padding-bottom: 2rem;
`;
const TopSection = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  font-size: 1.2rem;
`
const ContentSection = styled.div`
  margin: 2rem 0;
`;
const DraggerSection = styled(Dragger)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 2rem;
`;



const UploadNewDesignPageP: FC = () => {
  const [loading, setLoading] = useState(false);
  const [files, setFiles] = useState<any>();
  const history = useHistory();

  const currentItem = useStoreState((state: any) => state.cart.currentItem);
  const setCurrentItem = useStoreActions((actions: any) => actions.cart.setCurrentItem);

  const props = {
    name: "file",
    multiple: true,
    // maxCount: 1,
    onRemove: (file: any) => {
      const index = files.indexOf(file);
      const newFiles: any = files.slice();
      newFiles.splice(index, 1);

      return setFiles(newFiles);
    },
    beforeUpload: async (file: any, fileList: any) => {
      setLoading(false);
      return false;
    },
    onChange(info: any) {
      setFiles(info.fileList);
    },
  };

  const handleNextClick = () => {
    if (!files || files.length === 0) {
      notification.error({
        message: "Error",
        description: "Please select a STL file or files",
      });
    } else {
      let items = [...currentItem];
      files.forEach(file => {
        items.push({ files: [file]})
      });
      setCurrentItem(items);
      history.push("/design/published")
    }
  }

  return (
    <Spin spinning={loading}>
      <MainContainer>
        <HeaderComponent />
        <Col span={16} offset={4}>
          <ContentDiv>
            <TopSection>
              <SmallText>Upload your Design</SmallText>
              {/* <div> Select Design from the <Button type='primary' onClick={() => history.push('/marketplace')}>Marketplace</Button></div> */}
            </TopSection>
            <ContentSection>
              <DraggerSection
                {...props}
                accept=".stl"
                listType="picture-card"
                style={{ background: "white" }}
              >
                <Typography>Drag and Drop or</Typography>
                <Button
                  type="primary"
                  style={{ height: "48px", marginTop: "1rem" }}
                >
                  <div style={{ display: "flex" }}>
                    <img
                      src={UploadImg}
                      alt=""
                      style={{ marginRight: "1rem" }}
                    />
                    <SmallText style={{ color: "white" }}>
                      Select Files
                    </SmallText>
                  </div>
                </Button>
                <div>
                  <SmallText style={{ marginTop: "3rem", fontSize: "1.2rem" }}>
                    Printer Satisfaction Guarantee or your money back!
                  </SmallText>
                </div>
                <hr style={{ marginTop: "3rem" }} />
                <Descriptions>
                  <Descriptions.Item label="File Types">
                    STL files
                  </Descriptions.Item>
                  <Descriptions.Item label="File size">
                    {"< 1 GB"}
                  </Descriptions.Item>
                  <Descriptions.Item label="Part size">
                    {"< 3000*3000*3000 mm"}
                  </Descriptions.Item>
                </Descriptions>
              </DraggerSection>
              <div style={{ display: "flex", justifyContent: "flex-end" }}>
                <PrimaryButtonX
                  type="primary"
                  style={{ marginTop: "2rem" }}
                  onClick={handleNextClick}
                >
                  next
                </PrimaryButtonX>
              </div>
            </ContentSection>
          </ContentDiv>
        </Col>
        <FooterPublic3D />
      </MainContainer>
    </Spin>
  );
};

export default UploadNewDesignPageP;
